import React from "react";

// Shown as a full-overlay before the activity begins.
// Fades out when the user clicks "Begin".
export default function IntroGate({ intro, onBegin }) {
  const { title, subtitle, intention } = intro;

  return (
    <div
      className="tw-absolute tw-inset-0 tw-z-50 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-p-10 tw-text-center"
      style={{ background: "#FBF8EB" }}
    >
      <p className="tw-text-3xl tw-font-semibold at-intro-title" style={{ color: "#5B3FD6" }}>
        {title}
      </p>
      <p className="tw-text-[15px] tw-max-w-[300px] tw-leading-relaxed at-intro-subtitle" style={{ color: "rgba(26,26,26,0.65)" }}>
        {subtitle}
      </p>
      <p
        className="tw-text-[13px] tw-tracking-[2px] tw-uppercase tw-mt-2 at-intro-intention"
        style={{ color: "#CB5A3C" }}
      >
        {intention}
      </p>
      <button
        onClick={onBegin}
        className="at-intro-begin tw-mt-4 tw-px-8 tw-py-2.5 tw-rounded-3xl tw-text-[15px] tw-font-semibold tw-text-white tw-transition-all tw-duration-200 hover:tw-scale-105"
        style={{ background: "#5B3FD6", border: "none" }}
      >
        Begin
      </button>
    </div>
  );
}
